import React from 'react'
import { ImageBanner, Props } from 'component-library/banners/ImageBanner/ImageBanner'
import { createRegisterableComponent } from 'common/routing/page-definition'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ImageBanner extends Props {}

export const ImageBannerRegistration = createRegisterableComponent(
    'image-banner',
    (props: ImageBanner) => <ImageBanner {...props} />
)
